import { useContext, useEffect, useState } from "react";
import { ScrollView, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import PageTitle from "../../components/PageTitle";
import { GlobalContext } from "../../contexts/global";
import { SessionStorage } from "../../services/SessionStorage";
import * as Colors from "../../styles/colors";
import * as Fonts from "../../styles/typography";
import { dateFormatBR, numberToMoney } from "../../helpers/util";
import ButtonIcon from "../../components/ButonIcon";
import ReceiptEmail from "../../components/ReceiptEmail";
import ZigzagView from "react-native-zigzag-view";

export default function PaymentSessionHistory({ navigation }) {
  const { setLoading } = useContext(GlobalContext);
  const [history, setHistory] = useState([]);
  const [expandedItem, setExpandedItem] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setLoading({ show: true, message: "Carregando histórico" });
    const paymentHistory = SessionStorage.getPaymentHistory();
    setHistory(paymentHistory);
    setLoading({ show: false, message: "" });
  }, []);

  const getPaymentMethodIcon = (method) => {
    switch (method) {
      case 'credit_card':
        return 'credit-card';
      case 'wallet':
        return 'wallet';
      case 'shared_wallet':
        return 'account-group';
      case 'fraction':
        return 'chart-pie';
      default:
        return 'currency-usd';
    }
  };

  const toggleExpanded = (index) => {
    setExpandedItem(expandedItem === index ? null : index);
  };

  return (
    <PageTitle title={"HISTÓRICO DA SESSÃO"} navigation={navigation}>
      <ScrollView
        style={styles.viewSecundaria}
        contentContainerStyle={{
          alignItems: "center",
          paddingBottom: 8,
          flexGrow: 1,
        }}
      >
        {history.length > 0 ? (
          history.map((payment, index) => (
            <View style={styles.paymentItem}>
              <TouchableOpacity 
                key={index} 
                onPress={() => toggleExpanded(index)}
                activeOpacity={0.7}
              >
                <View style={styles.paymentHeader}>
                  <View style={styles.paymentInfo}>
                    <Icon 
                      name={getPaymentMethodIcon(payment.paymentMethod)} 
                      size={24} 
                      color={Colors.PRIMARY} 
                    />
                    <View style={styles.paymentDetails}>
                      <Text style={styles.unityName}>{payment.unityInfo?.nmUnidade}</Text>
                      <Text style={styles.ticketInfo}>
                        Ticket: {payment.unityInfo?.numeroTicket || 'N/A'} | 
                        Placa: {payment.unityInfo?.placa || 'N/A'}
                      </Text>
                      <Text style={styles.paymentDate}>
                        {dateFormatBR(payment.timestamp)}
                      </Text>
                    </View>
                  </View>
                  <Text style={styles.paymentValue}>
                    R$ {payment.unityInfo?.valorPagar}
                  </Text>
                </View>
                {payment.cardLastDigits && (
                  <Text style={styles.cardInfo}>
                    Cartão final {payment.cardLastDigits}
                  </Text>
                )}

                {expandedItem === index && (
                  <View>
                    <ZigzagView
                      style={styles.receiptView}
                      backgroundColor={Colors.WHITE}
                      surfaceColor={Colors.TICKET}
                    >
                      <View style={{ alignItems: "center" }}>
                        {payment.customer_receipt ? (
                          payment.customer_receipt.split("\n").map((line, index) => {
                            return (
                              <Text
                                key={index}
                                style={{ fontSize: Fonts.FONT_SIZE_16, fontWeight: "700" }}
                              >
                                {line.trim()}
                              </Text>
                            );
                          })
                        ) : (
                          <Text>{"Não encontrado"}</Text>
                        )}
                      </View>
                    </ZigzagView>
                    {payment.id_historic ? (
                      <View style={{ alignItems: "center", marginTop: 8 }}>
                        <ButtonIcon colorButton={Colors.PRIMARY} iconName={"email-outline"} onPress={() => {
                          setVisible(true);
                        }} size={32} />
                        
                      </View>
                    ) : null}
                  </View>
                  
                )}
              </TouchableOpacity>
              {payment.id_historic ? (
                <ReceiptEmail modalVisible={visible} setModalVisible={setVisible} receiptId={payment.id_historic}/>
              ) : null}
            </View>
            
          ))
        ) : (
          <View style={styles.emptyState}>
            <Icon name="history" size={128} color={Colors.BLACK} />
            <Text style={styles.emptyText}>
              Nenhum pagamento encontrado nesta sessão.
            </Text>
          </View>
        )}
      </ScrollView>
    </PageTitle>
  );
}

const styles = StyleSheet.create({
  viewSecundaria: {
    backgroundColor: Colors.WHITE,
    width: "100%",
    flex: 1,
    flexGrow: 1,
  },
  paymentItem: {
    width: "90%",
    backgroundColor: Colors.WHITE,
    borderRadius: 8,
    padding: 16,
    marginVertical: 8,
    elevation: 2,
    shadowColor: Colors.BLACK,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
  },
  paymentHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  paymentInfo: {
    flexDirection: "row",
    alignItems: "center",
  },
  paymentDetails: {
    marginLeft: 12,
  },
  unityName: {
    fontSize: Fonts.FONT_SIZE_16,
    fontWeight: "bold",
    color: Colors.BLACK,
  },
  ticketInfo: {
    fontSize: Fonts.FONT_SIZE_14,
    color: Colors.GRAY_DARK,
    marginTop: 2,
  },
  paymentDate: {
    fontSize: Fonts.FONT_SIZE_14,
    color: Colors.GRAY_DARK,
    marginTop: 4,
  },
  paymentValue: {
    fontSize: Fonts.FONT_SIZE_18,
    fontWeight: "bold",
    color: Colors.SUCCESS,
  },
  cardInfo: {
    fontSize: Fonts.FONT_SIZE_14,
    color: Colors.GRAY_DARK,
    marginTop: 8,
  },
  emptyState: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 32,
  },
  emptyText: {
    fontSize: Fonts.FONT_SIZE_16,
    color: Colors.GRAY_DARK,
    marginTop: 16,
    textAlign: "center",
  },
  receiptView: {
    padding: 8,
    marginVertical: 16,
    flex: 1,
    flexGrow: 1,
    marginHorizontal: 8,
    opacity: 0.9,
  },
}); 